import { EntityRole } from '../entities/entities'
import { TemplateStatus } from '../pathways/pathways'
import { QueueStyle, SubtaskPriority } from '../pathways/subtasks'

// Corresponds to libs/shared/recipes/processing/care_goals.py
export const INTENTIONALLY_BLANK_MEMBER_FACING_TITLE =
  'INTENTIONALLY_BLANK_TITLE'

export type VariantKey = {
  variantDisplay: string
  variantKey: string
}

export type TemplateBaseForm = {
  title: string
  variantSet: string | null
  memberFacingTitle: string | null
  intentionallyBlankMemberFacingTitle: Array<string>
} & BaseKeys

export type TemplateBasePayload = {
  title: string
  variantSet: VariantKey[]
  memberFacingTitle: string | null
} & BaseKeys

export enum PathwayAdminType {
  PATHWAY = 'playbook',
  TASK = 'task',
  SUBTASK = 'subtask',
}

export enum MemberFacingTheme {
  THYME = 'THYME',
  AON = 'AON',
}

export type BasicTemplateBase = {
  baseTemplateId: string
  title: string
  variants: VariantKey[]
  memberFacingTitle: string | null
} & BaseKeys

export type BaseKeys = {
  subtaskKey?: string
  pathwayKey?: string
  taskKey?: string
}

export type SubtaskTemplateVariantForm = {
  description: string
  responsibleRole: EntityRole | string | null
  estimatedMinutesToComplete: number | null
  hyperlinks: string
  priority: SubtaskPriority | string | null
  outreachMessage?: string | null
  memberFacingTheme: MemberFacingTheme | null
  variantKey: string
  variantDisplay: string
  queueStyle: QueueStyle
  isMemberFacing?: boolean
  isManuallyAddable: boolean
  templateStatus?: TemplateStatus
  reattemptCadence?: Array<number>
} & SubtaskTemplateVariantFormLabels

export type SubtaskTemplateVariantFormLabels = {
  formFlowLabel: string
  staffFormVariantLabel: string
  memberFormVariantLabel: string
}

export type SubtaskTemplateVariantPayload = {
  description?: string
  responsibleRole: EntityRole | string
  estimatedMinutesToComplete?: number
  hyperlinks: string | string[]
  priority: SubtaskPriority | string
  outreachMessage?: string | null
  memberFacingTheme?: MemberFacingTheme | null
  queueStyle: QueueStyle
  isMemberFacing?: boolean
  isManuallyAddable: boolean
  featureIds?: string[]
} & SubtaskTemplateVariantFormLabels

export type MapTasksSubtasks = {
  mappingTemplateId: string
  taskVariantId: string
  subtaskVariantId: string
}

export type TaskSubtaskDependency = {
  dependencyTemplateId: string
  taskVariantId: string
  mappingTemplateId: string
  dependsOnMappingTemplateId?: string | null
  minDaysToStart?: number | null
  maxDaysToComplete?: number | null
}

export type MapPathwaysTasks = {
  mappingTemplateId: string
  taskVariantId: string
  pathwayVariantId: string
}

export type PathwayTaskDependency = {
  dependencyTemplateId: string
  pathwayVariantId: string
  mappingTemplateId: string
  dependsOnMappingTemplateId?: string | null
  minDaysToStart?: number | null
  maxDaysToComplete?: number | null
}
